export const translations = {
  en: {
    heroHeading: "Selal",
    heroSubtext: "Download Selal App and enjoy the best deals",
    heroDescription: "Everything you need, from restaurants and cafés to groceries, desserts, flowers, and pharmacies, delivered fast and hassle-free.",
    contact: "Contact Us",
    register: "Join Us",
    aboutTitle: "About Selal",
    aboutParagraph1: "Selal is the number one super app in Oman",
    aboutParagraph2: "An all-in-one platform with multiple categories and services",
    aboutParagraph3: "Helping our partners reach more customers and grow faster",
    aboutParagraph4: "Selal combines technology with everyday needs for a reliable shopping experience",
    aboutParagraph5: "We continuously develop to lead the delivery market in Oman and beyond",
    
    // Selal Plus Section
    selalPlusTitle: "Save More with Selal Plus",
    selalPlusHeading: "Subscribe to Selal Plus and enjoy",
    unlimitedDeliveryTitle: "Unlimited Free Delivery",
    unlimitedDeliveryDesc: "Never pay delivery fees again on any order, any time of day.",
    exclusiveDiscountsTitle: "Exclusive Member Discounts",
    exclusiveDiscountsDesc: "Get special discounts and deals available only to Selal Plus members.",
    prioritySupportTitle: "Priority Customer Support",
    prioritySupportDesc: "Get faster support and priority handling for all your orders and inquiries.",
    signUpNowBtn: "Sign Up Now & Start Saving",
    selalPlusAlt: "Selal Plus QR Code",
    
    howToUseTitle: "How to Use Selal",
    step1Title: "1. Download the App",
    step1Desc: "Get Selal from the App Store or Google Play.",
    step2Title: "2. Choose What You Love",
    step2Desc: "Browse your favorite local and global vendors and select what you need.",
    step3Title: "3. Place Your Order",
    step3Desc: "Complete your payment, and we will deliver your order as quickly as possible.",
    whyChooseTitle: "Why Choose Selal",
    allInOneTitle: "All-in-One Variety",
    allInOneSubtitle: "Oman's #1 Super App",
    allInOneDesc: "From restaurants and cafés, to groceries and supermarkets, pharmacies, electronics stores, flowers, and everyday home essentials, everything you need in one place!",
    yourWayTitle: "Your Way, Your Choice",
    yourWaySubtitle: "Shop & Pay Your Way",
    yourWayDesc: "With Selal, choose the store you like and pay the way that suits you, whether cash or online. Flexibility made simple!",
    fastDeliveryTitle: "Fast & Relaxed Delivery",
    fastDeliverySubtitle: "Delivered Fast",
    fastDeliveryDesc: "Your orders reach you quickly while you relax at home. Selal… closer to everything you need!",
    footerRights: "All rights reserved",
    contactTitle: "Contact Selal",
    contactFormTitle: "We'd Love to Hear from You",
    contactName: "Your Name",
    contactEmail: "Your Email",
    contactMessage: "Your Message",
    contactSend: "Send Message",
    contactInfoTitle: "Contact Info",
    contactEmailLabel: "Email:",
    contactPhoneLabel: "Phone:",
    contactInstagramLabel: "Instagram:",
    messageSent: "Your message has been sent!",
    stepDownload: "Download the App",
    stepDownloadDesc: "Get the Selal app from the App Store or Play Store.",
    stepChoose: "Choose Items",
    stepChooseDesc: "Browse categories and add your favorite items to the cart.",
    stepConfirmPay: "Confirm & Pay",
    stepConfirmPayDesc: "Confirm your order and pay securely for fast delivery.",
    exploreCategoriesTitle: "What would you like to order today?",
    categoryMeatPoultry: "Meat & Poultry",
    categoryFishShops: "Fish Shops",
    categoryFruitsVeg: "Fruits & Vegetables",
    categoryGrocery: "Grocery Stores",
    categoryBakeries: "Bakeries & Pastries",
    categoryDrinks: "Drinks",
    categoryCoffeeNuts: "Coffee & Nuts",
    ourVendorsTitle: "Success Partners",
    vendor1: "Vendor 1",
    vendor2: "Vendor 2",
    vendor3: "Vendor 3",
    vendor4: "Vendor 4",
    exploreVendorsBtn: "Explore Partners",
    qualityServiceTitle: "Quality Service",
    qualityServiceDesc: "We ensure the best quality for all products and services.",
    easyPaymentTitle: "Easy Payment",
    easyPaymentDesc: "Secure and convenient payment options at your fingertips.",
    availableNowTitle: "Available Now",
    availableNowDesc1: "From restaurants & cafés, desserts & ice cream, to flowers, groceries & supermarkets, and even pharmacies, everything you need daily.",
    availableNowDesc2: " We deliver it all, fast!",
    availableNowDesc3: "Download the app today and enjoy the best deals.",
    appStoreBtn: "App Store",
    playStoreBtn: "Play Store",
    barcodeAlt: "Hands holding phone with barcode",
    // Rider
    riderSuccess: "Delivery Rider registered successfully!",
    riderFormHeading: "Join Our Team!",
    riderFormDesc: "If you own a car or motorcycle and are looking for an opportunity to increase your income, you've come to the right place. Register now!",
    riderName: "Rider Name",
    riderPhone: "Phone Number",
    riderID: "ID Number",
    riderNationality: "Nationality",
    riderResidence: "Residence",
    riderDeliveryCode: "Delivery Company Code (optional)",

    // Store
    storeSuccess: "Store registered successfully!",
    storeFormHeading: "Start Your Journey to Success!",
    storeFormDesc: "Join us to boost your business by easily reaching your customers, increasing your sales, and promoting your online business. Your inspiring story starts here.",
    storeName: "Store Name",
    vendorName: "Vendor Name",
    storePhone: "Phone Number",
    selectCategory: "Select a Category",

    // Hero & buttons
    registerHeroHeading: "Join Us Now",
    registerTitle: "Join Us",
    registerRiderBtn: "Join as Delivery Representative",
    registerStoreBtn: "Register Your Store",
    submitBtn: "Submit",
    vendorsHeroHeading: "Success Partners",
    vendorsTitle: "Success Partners",
    searchVendors: "Search partners...",
    noVendors: "No partners found.",
    all: "All",
    meat: "Meat",
    fish: "Fish",
    fruits: "Fruits",
    grocery: "Grocery",
    bakeries: "Bakeries",
    drinks: "Drinks",
    coffee: "Coffee",
    detergents: "Detergents",
    restaurants: "Restaurants",
    herbs: "Herbs",
    home: "Home",
    about: "About Us",
    vendors: "Partners",
    downloadApp: "Download App",
    appStore: "App Store",
    playStore: "Play Store",
    catering: "Catering",
    retail: "Retail",
    kitchen_utensils: "Kitchen Utensils",
    food: "Food",
    dessert: "Dessert",
    bakery_desserts: "Bakery & Desserts",
    juices: "Juices",
    health_nutrition: "Health & Nutrition",
    flowers_gifts: "Flowers & Gifts",
    categoryMeatPoultryDesc: "Explore over 50 meat & poultry shops",
    categoryFood: "Food",
    categoryFoodDesc: "Delicious meals from local restaurants",
    categoryFruitsVegDesc: "Fresh fruits and vegetables daily",
    categoryGroceryDesc: "Over 100 grocery stores to choose from",
    categoryBakeriesDesc: "Tasty baked goods from top bakeries",
    categoryDrinksDesc: "Refreshments for every taste",
    categoryCoffeeNutsDesc: "Premium coffee and nuts selection",

    // Added Categories
    categoryrestaurants: "Restaurants",
    categoryrestaurantsDesc: "Dine from top restaurants",
    categoryfruitsVeg: "Fruits & Vegetables",
    categoryfruitsVegDesc: "Fresh fruits and vegetables daily",
    categorygrocery: "Grocery Section",
    categorygroceryDesc: "Over 100 grocery stores to choose from",
    categorymeat: "Meat Section",
    categorymeatDesc: "Quality meats from trusted shops",
    categorychicken: "Chicken Section",
    categorychickenDesc: "Fresh chicken daily",
    categoryfishSeafood: "Fish & Seafood",
    categoryfishSeafoodDesc: "Fresh catch from the sea",
    categorynuts: "Nuts Section",
    categorynutsDesc: "Wide variety of nuts",
    categoryspicesCoffee: "Spices & Coffee",
    categoryspicesCoffeeDesc: "Premium spices and coffee",
    categorybakery: "Bakery",
    categorybakeryDesc: "Delicious baked goods",
    categorycafe: "Cafe",
    categorycafeDesc: "Relax at the best cafes",
    categorypharmacies: "Pharmacies",
    categorypharmaciesDesc: "Health and wellness products",
    categoryclothes: "Clothes",
    categoryclothesDesc: "Trendy clothes for all",
    categoryperfumes: "Perfumes",
    categoryperfumesDesc: "Exclusive perfumes",
    categorycosmetics: "Cosmetics",
    categorycosmeticsDesc: "Beauty and skincare products",
    categorylaundry: "Laundry",
    categorylaundryDesc: "Professional laundry services",
    categoryhotelReservations: "Hotel Reservations",
    categoryhotelReservationsDesc: "Book your stay easily",
    categoryrentCars: "Rent Cars",
    categoryrentCarsDesc: "Affordable car rentals",
    categorytaxi: "Taxi",
    categorytaxiDesc: "Fast taxi booking",

    // Button
    exploreInApp: "Explore in App",

    // Hero Section
"aboutCustomSubtext": "More Than Delivery, Your Everyday Companion",
"aboutHeroDescription": "At Selal, we believe life should be effortless. That's why we created a platform that brings together food, essentials, and services in one place",

// What Drives Us Section
"whatDrivesUsTitle": "What Drives Us",
"visionTitle": "Our Vision",
"visionDescription": "That Selal app becomes the ideal choice for all users in the Sultanate of Oman. To offer its services soon in the GCC region.",
"missionTitle": "Our Mission", 
"missionDescription": "Finding effective solutions to simplify the shopping process. Purchasing household essentials for all families and individuals residing in the Sultanate of Oman. Providing special offers and high quality.",
"objectivesTitle": "Our Objectives",
"objectivesDescription": "To make Selal a leading platform in Oman and the Gulf, simplify shopping with diverse options, and continuously expand services to meet customer needs.",

// Why Choose Selal Section (Updated)
"wideVarietyTitle": "Wide Variety",
"wideVarietyDesc": "A wide variety of stores and sections is one of Selal's prominent features",
"specialOffersTitle": "Special Offers", 
"specialOffersDesc": "Special offers on products with regular delivery.",
"paymentMethodsTitle": "Payment Methods",
"paymentMethodsDesc": "A variety of payment methods to provide an ideal shopping experience for the user.",

"vendorsCustomSubtext": "Your Business, Our Platform",
"vendorsHeroDescription": "Selal connects your brand with thousands of potential customers. Partner with us to expand your reach, increase visibility, and unlock new growth opportunities.",
"contactCustomSubtext": "Let's Stay Connected",
"contactHeroDescription": "Have a question, idea, or partnership in mind? Our team is here to listen and help, reach out anytime.",
"registerCustomSubtext": "Grow with Selal",
"registerHeroDescription": "Join as a Rider or a Partner Store, earn more, reach more, and be part of Selal.",
// Vendor Names
vendorALMLAS: "Almlas",
vendorAlRaisi: "Al Raisi",
vendorAwaniHouse: "Awani House",
vendorAlBandar: "Al Bandar",
vendorBenDawla: "Ben Dawla",
vendorOmanButchery: "Oman Butchery",
vendorChubbz: "Chubbz",
vendorGrillKingdom: "Grill Kingdom",
vendorHala: "Hala Bakery",
vendorHB: "HB Drinks",
vendorJalalEfendi: "Jalal Efendi",
vendorHikaytMahshi: "Hikayt Mahshi",
vendorMedames: "Medames",
vendorNutritionFit: "Nutrition Fit",
vendorPizzaLover: "Pizza Lover",
vendorRoses: "Roses & Gifts",
riderBtnText: "Be a delivery representative and earn income with Selal",
storeBtnText: "Expand your business by reaching more customers with us",

// Rider Info Cards
increaseIncomeTitle: "Increase Your Income",
increaseIncomeDesc: "Join Selal's network and earn extra income flexibly, according to your available time.",
flexibleWorkTitle: "Flexible Work",
flexibleWorkDesc: "Choose your own working hours and manage your delivery trips without complex commitments.",
reliableSupportTitle: "Reliable Support",
reliableSupportDesc: "Our team guides you every step of the way to make sure your deliveries are smooth and efficient.",
trainingGuidanceTitle: "Training & Guidance",
trainingGuidanceDesc: "Get all the tools and training you need to provide excellent service to customers.",

// Store Info Cards
moreCustomersTitle: "More Customers",
moreCustomersDesc: "We have many customers in your area looking for food from your restaurant. We help deliver their orders as quickly as possible.",
higherProfitsTitle: "Higher Profits",
higherProfitsDesc: "Easily increase your daily sales through our platform by continuously reaching new customers.",
effectiveMarketingTitle: "Effective Marketing",
effectiveMarketingDesc: "We promote your restaurant on our platform to attract more customers and boost daily orders.",
fullSupportTitle: "Full Support",
fullSupportDesc: "Our team is ready to assist you every step of the way to ensure your success and growth with Selal.",
// For Store Cards
customerReachTitle: "Customer Reach Expansion",
customerReachDesc: "Easily connect with new local customers and extend your restaurant's reach in your community.",
streamlinedOrdersTitle: "Streamlined Orders",
streamlinedOrdersDesc: "Manage your incoming orders effortlessly through our easy-to-use platform, saving time and reducing errors.",

// For Rider Cards
communityConnectionsTitle: "Community Connections",
communityConnectionsDesc: "Be part of a growing delivery network in your area and build strong connections with local businesses and customers.",
skillGrowthTitle: "Skill Growth",
skillGrowthDesc: "Enhance your professional skills in logistics, time management, and customer service while earning.",
ourValuesTitle: "Our Values",
diversityTitle: "Diversity",
diversityDesc: "Selal app includes a large number of stores specializing in various types of food products, as our goal is to save customers the hassle and effort of searching.",
qualityTitle: "Quality",
qualityDesc: "We adhere to total quality standards starting from the store's acceptance to join the application, through the shipping process, and up to providing the best payment methods that suit the customers.",
developmentTitle: "Development",
developmentDesc: "Selal application evolves periodically to reach the optimal model that ensures a great user experience and meets their needs accurately. The development process does not stop at a certain point.",
commitmentTitle: "Commitment",
commitmentDesc: "We are committed to providing all our services with high quality and ensuring that customer orders are delivered on time without delay. Our goal is to remain your first choice.",
sending: "Sending...",
messageError: "Failed to send message. Please try again or contact us directly at info@selalom.com",
ownerName: "Owner Name",
email: "Email",
storeAddress: "Store Address",
cityZone: "City / Zone",
closeBtn: "Close",
successTitle: "Success!",
errorTitle: "Error",
categoryhealth_nutrition: "Health & Nutrition",
categoryflowers_gifts: "Flowers & Gifts",
categorydessert: "Desserts",
categoryall: "All Categories",





  },
  ar: {
    heroHeading: "سلال",
    heroSubtext: "نزّل تطبيق سلال واستمتع بأحلى العروض",
  heroDescription: "من مطاعم وكافيهات، إلى بقالات، حلويات، ورد، وصيدليات ، يوصل لك بسرعة وبدون تعب",
    contact: "تواصل معنا",
    register: "انضموا معنا",
    aboutTitle: "عن سلال",
    aboutParagraph1: "سلال هو التطبيق الأول متعدد الخدمات في سلطنة عمان",
    aboutParagraph2: "منصة شاملة تضم فئات وخدمات متعددة لتوسيع وصول شركائنا للعملاء",
    aboutParagraph3: "تمكن شركائنا من زيادة العملاء وتحقيق نمو أسرع",
    aboutParagraph4: "سلال يجمع بين التقنية واحتياجات الحياة اليومية لتجربة شراء موثوقة ومريحة",
    aboutParagraph5: "نواصل تطوير التطبيق لنقود سوق التوصيل في عمان وخارجها",
    // Selal Plus Section - Omani dialect
    selalPlusTitle: "وفّر أكثر مع سلال بلس",
    selalPlusHeading: "اشترك في سلال بلس واستمتع بـ",
    unlimitedDeliveryTitle: "توصيل مجاني بلا حدود",
    unlimitedDeliveryDesc: "ما تدفع رسوم توصيل أبداً، أي طلب وأي وقت.",
    exclusiveDiscountsTitle: "خصومات حصرية للأعضاء",
    exclusiveDiscountsDesc: "احصل على خصومات وعروض خاصة بس لأعضاء سلال بلس.",
    prioritySupportTitle: "دعم عملاء متميز",
    prioritySupportDesc: "احصل على دعم أسرع ومعاملة مميزة لكل طلباتك واستفساراتك.",
    signUpNowBtn: "سجل الحين وابدأ توفر",
    selalPlusAlt: "باركود سلال بلس",
    
    howToUseTitle: "كيف تستخدم سلال",
    step1Title: "1. نزّل التطبيق",
    step1Desc: "نزّل سلال من App Store أو Google Play.",
    step2Title: "2. اختر اللي تريده",
    step2Desc: "تصفح المحلات اللي تحبها واختار اللي تحتاجه.",
    step3Title: "3. اطلب بسهولة",
    step3Desc: "ادفع وخلك مطمئن، بنوصل طلبك بسرعة.",
    whyChooseTitle: "ليش تختار سلال",
    allInOneTitle: "تنوع شامل",
    allInOneSubtitle: "التطبيق الأول في عمان",
    allInOneDesc: "من مطاعم وكافيهات، لبقالات وسوبرماركت، صيدليات، محلات إلكترونيات، زهور، وكل احتياجات البيت اليومية ، كل شيء تحتاجه في مكان واحد!",
    yourWayTitle: "على طريقتك",
    yourWaySubtitle: "اشتري وادفع كيف ما تريد",
    yourWayDesc: "مع سلال، اختر المحل اللي يعجبك وادفع بالطريقة اللي تناسبك ، سواء كاش أو أونلاين. مرونة بساطة!",
    fastDeliveryTitle: "توصيل سريع ومريح",
    fastDeliverySubtitle: "يوصلك بسرعة",
    fastDeliveryDesc: "طلباتك توصلك بسرعة وانت مرتاح في بيتك. سلال… أقرب لكل شيء تحتاجه!",
    footerRights: "© جميع الحقوق محفوظة",
    contactTitle: "تواصل مع سلال",
    contactFormTitle: "حابين نسمع منكم",
    contactName: "اسمك",
    contactEmail: "بريدك",
    contactMessage: "رسالتك",
    contactSend: "إرسال",
    contactInfoTitle: "معلومات التواصل",
    contactEmailLabel: "البريد:",
    contactPhoneLabel: "الهاتف:",
    contactInstagramLabel: "إنستغرام:",
    messageSent: "تم إرسال رسالتك بنجاح!",
    stepDownload: "نزّل التطبيق",
    stepDownloadDesc: "احصل على تطبيق سلال من App Store أو Play Store.",
    stepChoose: "اختر اللي يعجبك",
    stepChooseDesc: "تصفح الأقسام وأضف الأشياء للسلة.",
    stepConfirmPay: "أكد وادفع",
    stepConfirmPayDesc: "أكد طلبك وادفع بأمان للتوصيل السريع.",
    exploreCategoriesTitle: "شو حاب تطلب اليوم؟",
    categoryMeatPoultry: "لحوم ودواجن",
    categoryFishShops: "أسماك",
    categoryFruitsVeg: "فواكه وخضار",
    categoryGrocery: "بقالات",
    categoryBakeries: "مخابز وحلويات",
    categoryDrinks: "مشروبات",
    categoryCoffeeNuts: "قهوة ومكسرات",
    ourVendorsTitle: "شركاء النجاح",
    vendor1: "محل 1",
    vendor2: "محل 2",
    vendor3: "محل 3",
    vendor4: "محل 4",
    exploreVendorsBtn: "شوف كل الشركاء",
    qualityServiceTitle: "خدمة ممتازة",
    qualityServiceDesc: "نضمن لكم أفضل جودة للمنتجات والخدمات.",
    easyPaymentTitle: "دفع سهل",
    easyPaymentDesc: "خيارات دفع آمنة ومريحة عندك.",
    availableNowTitle: "متوفر الحين",
availableNowDesc1: "من مطاعم وكافيهات، حلويات وآيسكريم، لزهور وبقالات وسوبرماركت، وحتى صيدليات،",
availableNowDesc2: "كل شيء تحتاجه يومياً. نوصل لك كل شيء بسرعة!",
    availableNowDesc3: "نزّل التطبيق الحين واستمتع بأحلى العروض.",
    appStoreBtn: "آب ستور",
    playStoreBtn: "بلاي ستور",
    barcodeAlt: "يد ماسكة الهاتف مع الباركود",
    // Rider
    riderSuccess: "تم تسجيل موظف التوصيل بنجاح!",
    riderFormHeading: "انضم لفريقنا!",
    riderFormDesc: "إذا عندك سيارة أو دراجة وتبغى تزيد دخلك، وصلت للمكان الصح. سجل الحين!",
    riderName: "اسم المندوب",
    riderPhone: "رقم الهاتف",
    riderID: "رقم الهوية",
    riderNationality: "الجنسية",
    riderResidence: "مكان السكن",
    riderDeliveryCode: "كود شركة التوصيل (اختياري)",

    // Store
    storeSuccess: "تم تسجيل المتجر بنجاح!",
    storeFormHeading: "ابدأ مشوارك معانا!",
    storeFormDesc: "انضم لسلال عشان توصل لعملاءك بسهولة، تزيد مبيعاتك، وتوسع تجارتك أونلاين. قصتك تبدأ من هنا.",
    storeName: "اسم المتجر",
    vendorName: "اسم التاجر",
    storePhone: "رقم الهاتف",
    selectCategory: "اختر الفئة",

    // Hero & buttons
    registerHeroHeading: "انضموا الحين",
    registerTitle: "انضموا معنا",
    registerRiderBtn: "سجل كمندوب توصيل",
    registerStoreBtn: "سجل متجرك",
    submitBtn: "إرسال",
    vendorsHeroHeading: "شركاء النجاح",
    vendorsTitle: "شركاء النجاح",
    searchVendors: "ابحث عن الشركاء...",
    noVendors: "ما حصلنا شركاء.",
    all: "الكل",
    meat: "لحوم",
    fish: "أسماك",
    fruits: "فواكه",
    grocery: "بقالات",
    bakeries: "مخابز",
    drinks: "مشروبات",
    coffee: "قهوة ومكسرات",
    detergents: "منظفات",
    restaurants: "مطاعم",
    herbs: "أعشاب",
    home: "الرئيسية",
    about: "عن سلال",
    vendors: "الشركاء",
    downloadApp: "نزّل التطبيق",
    appStore: "آب ستور",
    playStore: "بلاي ستور",
    catering: "تموين",
    retail: "تجزئة",
    kitchen_utensils: "أدوات مطبخ",
    food: "طعام",
    dessert: "حلويات",
    bakery_desserts: "مخبوزات وحلويات",
    juices: "عصائر",
    health_nutrition: "صحة وتغذية",
    flowers_gifts: "زهور وهدايا",
    categoryMeatPoultryDesc: "اكتشف أكثر من 50 محل للحوم والدواجن",
    categoryFood: "أكل",
    categoryFoodDesc: "أكلات لذيذة من المطاعم القريبة",
    categoryFruitsVegDesc: "خضار وفواكه طازجة كل يوم",
    categoryGroceryDesc: "أكثر من 100 بقالة تختار منها",
    categoryBakeriesDesc: "حلويات طيبة من أفضل المخابز",
    categoryDrinksDesc: "مشروبات تناسب كل الأذواق",
    categoryCoffeeNutsDesc: "أفضل أنواع القهوة والمكسرات",

    // Added Categories
    categoryrestaurants: "المطاعم",
    categoryrestaurantsDesc: "تناول الطعام من أفضل المطاعم",
    categoryfruitsVeg: "الفواكه والخضروات",
    categoryfruitsVegDesc: "فواكه وخضروات طازجة يومياً",
    categorygrocery: "قسم البقالة",
    categorygroceryDesc: "أكثر من 100 متجر بقالة للاختيار منها",
    categorymeat: "قسم اللحوم",
    categorymeatDesc: "لحوم عالية الجودة من متاجر موثوقة",
    categorychicken: "قسم الدواجن",
    categorychickenDesc: "دجاج طازج يومياً",
    categoryfishSeafood: "الأسماك والمأكولات البحرية",
    categoryfishSeafoodDesc: "صيد طازج من البحر",
    categorynuts: "قسم المكسرات",
    categorynutsDesc: "تشكيلة واسعة من المكسرات",
    categoryspicesCoffee: "التوابل والقهوة",
    categoryspicesCoffeeDesc: "بهارات وقهوة مميزة",
    categorybakery: "المخبوزات",
    categorybakeryDesc: "مخبوزات لذيذة",
    categorycafe: "المقاهي",
    categorycafeDesc: "استمتع بأفضل المقاهي",
    categorypharmacies: "الصيدليات",
    categorypharmaciesDesc: "منتجات صحية وعلاجية",
    categoryclothes: "الملابس",
    categoryclothesDesc: "ملابس عصرية للجميع",
    categoryperfumes: "العطور",
    categoryperfumesDesc: "عطور حصرية",
    categorycosmetics: "مستحضرات التجميل",
    categorycosmeticsDesc: "منتجات تجميلية وعناية بالبشرة",
    categorylaundry: "غسيل الملابس",
    categorylaundryDesc: "خدمات غسيل احترافية",
    categoryhotelReservations: "حجوزات الفنادق",
    categoryhotelReservationsDesc: "احجز إقامتك بسهولة",
    categoryrentCars: "تأجير سيارات",
    categoryrentCarsDesc: "سيارات للإيجار بأسعار مناسبة",
    categorytaxi: "تاكسي",
    categorytaxiDesc: "احجز تاكسي بسرعة",

    // Button
    exploreInApp: "استكشف في التطبيق",

    // Hero Section
"aboutCustomSubtext": "أكثر من توصيل ، رفيجك كل يوم",
"aboutHeroDescription": "في سلال، نحن نؤمن إن الحياة لازم تكون سهلة. عشان جذا سوينا منصة تجمع لك الأكل والضروريات والخدمات في مكان واحد ، سريع وموثوق ومصمم حولك.",

// What Drives Us Section
"whatDrivesUsTitle": "شنو يحركنا",
"visionTitle": "رؤيتنا",
"visionDescription": "إن تطبيق سلال يصير الخيار المثالي لكل المستخدمين في سلطنة عمان. ونقدم خدماتنا قريب في منطقة مجلس التعاون الخليجي.",
"missionTitle": "مهمتنا", 
"missionDescription": "نلاقي حلول فعالة نبسط بيها عملية التسوق. نشتري الضروريات البيتية لكل العائلات والأفراد اللي يعيشون في سلطنة عمان. ونوفر عروض خاصة وجودة عالية.",
"objectivesTitle": "أهدافنا",
"objectivesDescription": "إن سلال يصير واحد من المشاريع الرائدة في سلطنة عمان والخليج العربي. نسهل عملية الشراء للمستهلك بتوفير مجموعة واسعة من الخيارات. نوسع نشاط التطبيق نضيف خدمات أكثر تلبي احتياجات الزبون.",

// Why Choose Selal Section (Updated)
"wideVarietyTitle": "تنوع واسع",
"wideVarietyDesc": "تنوع واسع من المحلات والأقسام، هذا واحد من أهم مميزات سلال",
"specialOffersTitle": "عروض خاصة", 
"specialOffersDesc": "عروض خاصة على المنتجات مع توصيل منتظم.",
"paymentMethodsTitle": "طرق الدفع",
"paymentMethodsDesc": "تنوع في طرق الدفع نوفر تجربة تسوق مثالية للمستخدم.",

"vendorsCustomSubtext": "شغلك، منصتنا",
"vendorsHeroDescription": "سلال يوصل علامتك التجارية بآلاف الزبائن المحتملين. شارك معانا تزيد وصولك وتزيد الرؤية وتفتح فرص نمو جديدة.",
"contactCustomSubtext": "يلا نبقى متواصلين",
"contactHeroDescription": "عندك سؤال أو فكرة أو تفكر في شراكة؟ فريقنا هني نسمع لك ونساعدك ، تواصل معانا أي وقت.",
"registerCustomSubtext": "اكبر مع سلال",
"registerHeroDescription": "انضم كسائق أو متجر شريك ، اكسب أكثر، وصل أكثر، وكن جزء من سلال.",
// Vendor Names (English & Omani Arabic)
vendorALMLAS: "الملاس",
vendorAlRaisi: "الرئيسي",
vendorAwaniHouse: "بيت الأواني",
vendorAlBandar: "البندر التركي",
vendorBenDawla: "بن دولة",
vendorOmanButchery: "مركز ذبائح عمان للحوم",
vendorChubbz: "تشوبز",
vendorGrillKingdom: "مملكة الشوي",
vendorHala: "هلا للمخبوزات",
vendorHB: "إتش بي للمشروبات",
vendorJalalEfendi: "جلال أفندي",
vendorHikaytMahshi: "حكاية محشي",
vendorMedames: "مدمس",
vendorNutritionFit: "التغذية الصحيّة",
vendorPizzaLover: "بيزا لوفر",
vendorRoses: "روزس",

riderBtnText: "كن مندوب توصيل واكسب دخل مع سلال",
storeBtnText: "وسّع نشاطك التجاري ووصل لعملاء أكثر معانا",

// Rider Info Cards
increaseIncomeTitle: "زيّد دخلك",
increaseIncomeDesc: "انضم لشبكة سلال واكسب دخل إضافي بمرونة، على حسب وقتك المتاح.",
flexibleWorkTitle: "عمل مرن",
flexibleWorkDesc: "اختر ساعات عملك وأدير رحلات التوصيل بدون التزامات معقدة.",
reliableSupportTitle: "دعم موثوق",
reliableSupportDesc: "فريقنا يرشدك في كل خطوة عشان تضمن توصيلاتك تمشي بسلاسة وكفاءة.",
trainingGuidanceTitle: "تدريب وإرشاد",
trainingGuidanceDesc: "احصل على كل الأدوات والتدريب اللي تحتاجه عشان تقدم خدمة ممتازة للعملاء.",

// Store Info Cards
moreCustomersTitle: "عملاء أكثر",
moreCustomersDesc: "عندنا عملاء كثار في منطقتك يدورون على أكل من مطعمك. نساعدك نوصل طلباتهم بأسرع وقت.",
higherProfitsTitle: "أرباح أعلى",
higherProfitsDesc: "زيّد مبيعاتك اليومية بسهولة من خلال منصتنا ووصل لعملاء جدد باستمرار.",
effectiveMarketingTitle: "تسويق فعّال",
effectiveMarketingDesc: "نسوّق لمطعمك في منصتنا عشان نجذب عملاء أكثر ونزيّد الطلبات اليومية.",
fullSupportTitle: "دعم كامل",
fullSupportDesc: "فريقنا جاهز يساعدك في كل خطوة عشان نضمن نجاحك ونموك مع سلال.",
// For Store Cards
customerReachTitle: "توسيع قاعدة الزبائن",
customerReachDesc: "تواصل بسهولة مع زبائن جدد في منطقتك ووسّع انتشار مطعمك في المجتمع.",
streamlinedOrdersTitle: "طلبات منظمة",
streamlinedOrdersDesc: "دير طلباتك الداخلة بكل سهولة من خلال منصتنا السهلة، ووفر وقتك وقلل الأخطاء.",

// For Rider Cards
communityConnectionsTitle: "علاقات مجتمعية",
communityConnectionsDesc: "كون جزء من شبكة توصيل متنامية في منطقتك وبني علاقات قوية مع المحلات والزبائن المحليين.",
skillGrowthTitle: "تطوير المهارات",
skillGrowthDesc: "طور مهاراتك المهنية في اللوجستيات وإدارة الوقت وخدمة العملاء وأنت تكسب.",
ourValuesTitle: "قيمنا",
diversityTitle: "التنوع",
diversityDesc: "تطبيق سلال يضم عدد كبير من المحلات المتخصصة في مختلف أنواع المنتجات الغذائية، حيث هدفنا توفير عناء ومجهود البحث على العملاء.",
qualityTitle: "الجودة",
qualityDesc: "نلتزم بمعايير الجودة الشاملة ابتداءً من قبول المحل للانضمام للتطبيق، مروراً بعملية الشحن، ووصولاً لتوفير أفضل طرق الدفع اللي تناسب العملاء.",
developmentTitle: "التطوير",
developmentDesc: "تطبيق سلال يتطور بشكل دوري للوصول للنموذج الأمثل اللي يضمن تجربة مستخدم رائعة ويلبي احتياجاتهم بدقة. عملية التطوير ما توقف عند نقطة معينة.",
commitmentTitle: "الالتزام",
commitmentDesc: "ملتزمين بتقديم كل خدماتنا بجودة عالية وضمان توصيل طلبات العملاء في الوقت المحدد بدون تأخير. هدفنا نبقى خياركم الأول.",
sending: "يرسل الحين...",
messageError: "ما قدرنا نرسل الرسالة. حاول مرة ثانية أو تواصل معانا على info@selalom.com",
// Contact Page Translations (Omani Arabic)
successTitle: "نجح!",
errorTitle: "خطأ",
closeBtn: "إغلاق",
ownerName: "اسم المالك",
email: "البريد الإلكتروني",
storeAddress: "عنوان المحل",
cityZone: "المدينة / المنطقة",
categoryhealth_nutrition: "صحة وتغذية",
categoryflowers_gifts: "ورود وهدايا",
categorydessert: "حلويات",
categoryall: "كل الأصناف",
  }
};